import { render, staticRenderFns } from "./KpiCards.vue?vue&type=template&id=9094bbe2&scoped=true&"
import script from "./KpiCards.vue?vue&type=script&lang=ts&"
export * from "./KpiCards.vue?vue&type=script&lang=ts&"
import style0 from "./KpiCards.vue?vue&type=style&index=0&id=9094bbe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9094bbe2",
  null
  
)

export default component.exports